module.exports = __webpack_public_path__ + "../static/img/base_cisco_ios.a3d38d3f.png";